/* import __COLOCATED_TEMPLATE__ from './plan-editor.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { ExternalPlanWireFormat } from 'embercom/objects/inbox/external-plan';
interface Signature {
  Args: {
    predicate: $TSFixMe;
    changePredicateValue: (value: string) => void;
    changePredicateComparison: (value: string) => void;
  };
}

export default class PlanEditor extends Component<Signature> {
  @service appService: $TSFixMe;
  @tracked emberPlans: ExternalPlanWireFormat[] = [];

  constructor(owner: any, args: Signature['Args']) {
    super(owner, args);
    this.emberPlans = this.appService.app?.plans || [];
  }

  get dropdownOptions() {
    return this.emberPlans.map((plan) => ({
      text: plan.name,
      value: plan.id,
    }));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Predicates::Editors::PlanEditor': typeof PlanEditor;
  }
}
